import AmioHttpService from './amio-http.service'
import last from 'ramda/src/last'

class DeploymentService extends AmioHttpService {

  deploy(botId, channelId) {
    return this.requestPut(`/bots/${botId}/deployments`, {
      channel_id: channelId
    })
      .then(response => adapt(response.data))
      .catch(err => {
        throw this.handleError(err)
      })
  }

  delete(botId, channelId) {
    return this.requestDelete(`/bots/${botId}/deployments?channelId=${channelId}`)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list(botId) {
    return this.requestGet(`/bots/${botId}/deployments`)
      .then(response => response.data)
      .then(deployments => {
        return deployments.map(adapt)
      })
      .catch(err => {
        throw this.handleError(err)
      })
  }

  async getLast(botId) {
    const deployments = await this.list(botId)
    return last(deployments) || null
  }

}

function adapt(deployment) {
  return {
    channel: deployment.channel
  }
}

export default new DeploymentService()

